import { getTenantId } from '@/mixins/Helpers';

const themes = {
    'adyk.': () => import('./adyk.css'),
    'gtc.': () => import('./gtc.css'),
    'qvct.': () => import('./qvct.css'),
    'sdp.': () => import('./sdp.css'),
    'wefa.': () => import('./wefa.css'),
    'senakpon.' : () => import('./senakpon.css')
};

export const loadTenantTheme = async () => {
    const tenantId = getTenantId();
    const loader = themes[tenantId];
    if (loader) {
        try {
            await loader();
        } catch (e) {
            console.error("Erreur chargement du thème:", e);
        }
    } else {
        console.warn("Aucun thème trouvé pour:", tenantId);
    }
};
